/**
 * I tipi di approvazione e la regola che divide le assenze (23-10-2026). In un file a sé, senza
 * letture: lo usano sia le code (`approvalQueues.ts`) sia la coda delle assenze.
 */
export type LeaveKind = 'vacation' | 'permit' | 'other';
export type ApprovalKind = LeaveKind | 'smart' | 'expense' | 'swap' | 'vehicle' | 'travel' | 'room' | 'clientChange' | 'subscription';

export const APPROVAL_TABS: { kind: ApprovalKind; label: string }[] = [
  { kind: 'vacation', label: 'Ferie' },
  { kind: 'permit', label: 'Permessi' },
  { kind: 'other', label: 'Altre assenze' },
  { kind: 'smart', label: 'Smart working' },
  { kind: 'expense', label: 'Note spese' },
  { kind: 'swap', label: 'Scambi turno' },
  { kind: 'vehicle', label: 'Mezzi' },
  { kind: 'travel', label: 'Trasferte' },
  { kind: 'room', label: 'Sale riunioni' },
  { kind: 'clientChange', label: 'Variazioni anagrafiche' },
  { kind: 'subscription', label: 'Abbonamenti' },
];

/** Ferie, permessi o altro, dal tipo di assenza. */
export function leaveKindOf(t?: { category?: string | null; unitOfMeasure?: string | null } | null): LeaveKind {
  if (t?.category === 'vacation') return t.unitOfMeasure === 'hours' ? 'permit' : 'vacation';
  if (t?.category === 'permit') return 'permit';
  return 'other';
}

